// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iwxt","input":"styles_input__1zYqx"};